module.exports = __webpack_public_path__ + "img/stageSection01.0795406e.png";